import { render } from "./NotificationsPanel.vue?vue&type=template&id=47453e3a&scoped=true"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"

import "./NotificationsPanel.vue?vue&type=style&index=0&id=47453e3a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47453e3a"]])

export default __exports__